import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function() {
    'use strict';

    angular.module('app').component('dollhouse', {
        template: require('./doll-house.html'),
        controller: DollHouseCtrl,
        controllerAs: 'vm'
    });

    DollHouseCtrl.$inject = [
        '$scope',
        '$state',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function DollHouseCtrl(
        $scope,
        $state,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {
        var vm = this;

        vm.version = UTILS.version;
        vm.logo = require('Images/nav-logo.png');
        vm.logo_dh = require('Images/share_lab.png');
        
        $rootScope.title = 'DayoungxShareLab Demo Class';

        vm.data = {};
        vm.transaction_code = '';

        vm.submit = function() {

            vm.loading = true;
            var request = {
                method: 'GET',
                route: URLS.base + `/doll_house/`+vm.transaction_code,
            };

            QueryService.query(request)
                .then(
                    function(response) {

                        const data = response.data.data;
                        
                        if(data.items.length === 0) {
                            logger.error('잘못된 쿠폰 코드');
                            return;
                        }

                        if(data.items.length === 1 && data.items[0].date_used) {
                            logger.error(`죄송합니다. 쿠폰 코드를 이미 사용 중입니다. 새 쿠폰 코드를 사용하십시오.`);
                            return;
                        }

                        $location.path('demo-teacher').search({
                            coupon_code: vm.transaction_code
                        });


                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        };

    }
})();


// WEBPACK FOOTER //
// ./src/app/components/doll-house/coupon_code/doll-house.component.js